const TestFeature = () => {
  return (
    <div>
      <h1>This is the test feature</h1>
    </div>
  );
};

export default TestFeature;
